// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2Jpsb1nXZNw5Naqpd8b9J2"};